import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { AccountPaymentFavoriteService } from '@wlp/ui-bs-account-payment-favorite';
import { BilletService, BilletLotService } from '@wlp/ui-bs-cashin';
import { UserInfoService } from '@wlp/ui-bs-login';
import { LotWithBilletCompletedDto, BilletDto } from '@wlp/ui-px-cashin';
import * as moment from 'moment';


@Component({
  selector: 'ui-t-billet-info',
  templateUrl: './billet-info.html',
  styleUrls: ['./billet-info.scss'],
})
export class BilletInfo implements OnInit {

  @Input() lot: LotWithBilletCompletedDto = null;
  @Input() billet: BilletDto = null;

  constructor(
    public modalController: ModalController,
    public popoverController: PopoverController,
    public router: Router,
    protected userInfoService: UserInfoService,
    public billetService: BilletService,
    public billetLotService: BilletLotService,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
  ) {
    moment.locale('pt-br');
  }
  ngOnInit() {}
}
